import React, { useState } from "react";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { getContentByKey, getHtmlByKey } from "../../utils/document";
import { getToolTipAttributes } from "../../utils/tooltip";
import MaterialIcon from "./MaterialIcon";

const InfoTooltip = ({ documentKey }) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const htmlContent = getHtmlByKey(documentKey);
  const content = getContentByKey(documentKey);

  const handleToggleTooltip = () => {
    setIsTooltipOpen(!isTooltipOpen);
  };

  const AddInfo = ({ htmlContent }) => <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;

  return (
    <div style={{ userSelect: "text", height: "18px" }}>
      <div {...getToolTipAttributes(content)} className="cursor_pointer">
        <MaterialIcon name="info" className="font_size_large font_weight_normal" onClick={handleToggleTooltip} />
      </div>
      <BuilderModal
        isOpen={isTooltipOpen}
        onClose={() => setIsTooltipOpen(false)}
        modalName={documentKey.split("_").join(" ")}
      >
        <AddInfo htmlContent={htmlContent} />
      </BuilderModal>
    </div>
  );
};

export default InfoTooltip;
